import { css, CSSResult } from 'lit'
import { csColorBackground, csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder, csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csShadow } from '@cloudsuite/mosaic-shared/styles/shadows.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'


export const cseModal = {
  backgroundColor: css`var(--cse-modal-background-color, ${csColorBackground.primary})`,
  borderRadius: css`var(--cse-modal-border-radius, ${csBorder.radiusMinimal})`,
  boxShadow: css`var(--cse-modal-box-shadow, ${csShadow.default})`,
  transitionDuration: css`var(--cse-modal-transition-duration, ${csTransition.duration})`,
  transitionTimingFunction: css`var(--cse-modal-transition-timing-function, ${csTransition.timingFunction})`,
  width: css`var(--cse-modal-width, 384px)`,
  largeWidth: css`var(--cse-modal-large-width, 600px)`,
  mobileMargin: css`var(--cse-modal-mobile-margin, ${csSpacing.spacing06})`,

  headerBackgroundColor: css`var(--cse-modal-header-background-color, ${csColorBackground.secondary})`,
  headerPaddingBlock: css`var(--cse-modal-header-padding-y, ${csSpacing.spacing06})`,
  headerPaddingInline: css`var(--cse-modal-header-padding-x, ${csSpacing.spacing06})`,

  iconColor: css`var(--cse-modal-icon-color, ${csColorText.white})`,
  iconBackgroundColorError: css`var(--cse-modal-icon-background-color-error, ${csColorFunctional.error})`,
  iconBackgroundColorInfo: css`var(--cse-modal-icon-background-color-info, ${csColorFunctional.info})`,
  iconBackgroundColorSuccess: css`var(--cse-modal-icon-background-color-success, ${csColorFunctional.success})`,
  iconBackgroundColorWarning: css`var(--cse-modal-icon-background-color-warning, ${csColorFunctional.warning})`,

  bodyGap: css`var(--cse-modal-body-gap, ${csSpacing.spacing06})`,
  bodyPaddingBlock: css`var(--cse-modal-body-padding-y, ${csSpacing.spacing06})`,
  bodyPaddingInline: css`var(--cse-modal-body-padding-x, ${csSpacing.spacing06})`,

  footerGap: css`var(--cse-modal-footer-gap, ${csSpacing.spacing05})`,
  footerPaddingInline: css`var(--cse-modal-footer-padding-x, ${csSpacing.spacing06})`,
  footerPaddingBlock: css`var(--cse-modal-footer-padding-y, ${csSpacing.spacing06})`,
}

export const style: CSSResult = css`
  :host {
    display: block;
  }

  :host([hidden]) {
    display: none;
  }

  dialog {
    background-color: ${cseModal.backgroundColor};
    border: none;
    border-radius: ${cseModal.borderRadius};
    box-shadow: ${cseModal.boxShadow};
    padding: 0;
    position: fixed;
    width: ${cseModal.width};
  }
  
  @media (max-width: ${SCREENS.small}) {
    dialog {
      width: calc(100vw - ${cseModal.mobileMargin} * 2);
      max-width: calc(100vw - ${cseModal.mobileMargin} * 2);
    }
  }

  .size-large {
    width: ${cseModal.largeWidth};
  }

  .fullscreen {
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
    max-height: 100vh;
    margin: 0;
  }

  .fullscreen[open] {
    display: flex;
    flex-flow: column;
  }

  .fullscreen .body {
    flex: 1;
  }

  .header {
    display: block;
    background-color: ${cseModal.headerBackgroundColor};
    padding-block: ${cseModal.headerPaddingBlock};
    padding-inline: ${cseModal.headerPaddingInline};
    text-align: center;
  }

  .body {
    display: flex;
    gap: ${cseModal.bodyGap};
    padding-block: ${cseModal.bodyPaddingBlock};
    padding-inline: ${cseModal.bodyPaddingInline};
    flex-direction: column;
    align-items: center;
  }

  .footer {
    display: flex;
    gap: ${cseModal.footerGap};
    padding-block: ${cseModal.footerPaddingBlock};
    padding-inline: ${cseModal.footerPaddingInline};
  }

  .size-large .footer {
    justify-content: space-around;
  }

  .size-default cse-button,
  .size-default ::slotted(cse-button) {
    flex: 1;
  }

  dialog::backdrop {
    position: fixed;
    inset: 0;
    background: #00000059; /* NOTE: does not work with CSS variable */
  }

  dialog.no-backdrop::backdrop {
    opacity: 0;
  }

  .icon {
    align-items: center;
    background-color: transparent;
    border-radius: ${csBorder.radiusFull};
    color: ${cseModal.iconColor};
    display: flex;
    font-weight: 300;
    justify-content: center;
    height: 60px;
    width: 60px;
  }

  .variant-error .icon {
    background-color: ${cseModal.iconBackgroundColorError};
  }

  .variant-info .icon {
    background-color: ${cseModal.iconBackgroundColorInfo};
  }

  .variant-success .icon {
    background-color: ${cseModal.iconBackgroundColorSuccess};
  }

  .variant-warning .icon {
    background-color: ${cseModal.iconBackgroundColorWarning};
  }
`
